import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter, useHistory } from "react-router-dom";
import { Colors, Constants, Languages } from '../../common';
import { styled, useTheme } from '@mui/material/styles';
import { Skeleton, Snackbar, useMediaQuery, Dialog, DialogTitle, DialogContent, IconButton, DialogActions, Button } from '@mui/material';
import MuiAlert from '@mui/material/Alert';

import PlanItem from '../Plan/PlanItem';
import { actions } from '../../redux/UserRedux';
import CloseIcon from '@mui/icons-material/Close';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { UserAPI } from '../../services';
import { getApiHeader } from '../../utils/CommonFunctions';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const stripePromise = loadStripe(Constants.StripePublishKey);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

const ChangeBundle = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [openModal, setOpenModal] = React.useState(false);
    const [customer_activations, setCustomerActivations] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const planList = useSelector((state) => state.user.topUPList);
    const isLoading = useSelector((state) => state.user.isLoading);
    const colorData = useSelector((state) => state.user.colorData);
    const eSIMName = useSelector((state) => state.user.eSIMName);

    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState(Constants.SnackBarType.Error);
    const activation_id = useSelector((state) => state.user.activationId);

    useEffect(() => {
        // setIsLoading(true)
        openLoader()
        sessionStorage.setItem('type', Languages.TopupESIM);
        getActivations()
        getTopupPlanList(activation_id)
    },[] );

    const updateShowMsg = useCallback((val) => {
        dispatch(actions.updateShowMsg(val));
    }, [dispatch]);

    const openLoader = useCallback(() => {
        actions.openLoader(dispatch);
    }, [dispatch]);

    // const openCloseAlert = useCallback((isShowAlert, msg, page) => {
    //     dispatch(actions.openCloseAlert(isShowAlert, msg, page));
    // }, [dispatch]);


    const closeLoader = useCallback(() => {
        actions.closeLoader(dispatch);
    }, [dispatch]);

    const setActivationId = useCallback((activationId, eSIMName) => {
        dispatch(actions.setActivationId(activationId, eSIMName));
    }, [dispatch]);


    const getTopupPlanList = useCallback((id) => {
        actions.getTopupPlanList(dispatch, id);
    }, [dispatch]);

    const clearPlanList = useCallback(() => {
        actions.clearPlanList(dispatch);
    }, [dispatch]);


    const handleModalClose = () => {
        setOpenModal(false);
    };

    const showMsg = (message, type) => {
        setMessage(message);
        setMsgType(type);
        setOpen(true);
    }

    const handleClose = (event, reason) => {
        // if (reason === 'clickaway') {
        //   return;
        // }
        updateShowMsg(false)
        setOpen(false);
    };


    const onContinueTopup = async (data, pageType, url) => {

        openLoader()
        let headers = await getApiHeader();
        const response = await UserAPI.postData(data, headers, 'top-up')
        if (response !== undefined) {
            if (response.status === 200) {
                showMsg(response.message, Constants.SnackBarType.Success)
                closeLoader();
            } else {
                closeLoader();
               
                showMsg(response.message, Constants.SnackBarType.Error)
            }
        } else {
            closeLoader()
            showMsg(Languages.ServerError, Constants.SnackBarType.Error);
        }
    }


    const getActivations = async () => {
        openLoader();
        setCustomerActivations([])
        let headers = await getApiHeader();
        const response = await UserAPI.postData({}, headers, Constants.UserActivations)
        console.log('UserActivations ==>', response);
        if (response !== undefined) {
            if (response.status === 200) {
               
                let data = response.data.activations;

                setCustomerActivations(data);
                closeLoader();

            } else {
                closeLoader();
                showMsg(response.message, Constants.SnackBarType.Error)
            }
        } else {
            closeLoader();
            showMsg(Languages.ServerError, Constants.SnackBarType.Error);
        }
    };

    const handleChange = async (e) => {
        var activationId = e.target.selectedOptions[0].getAttribute('activationId');
        let country_name = e.target.selectedOptions[0].getAttribute('country_name');
        let iccid = e.target.selectedOptions[0].getAttribute('iccid');
        console.log(activationId, country_name, iccid);
        await setActivationId(activationId, country_name + ' - ' + iccid)
        await getTopupPlanList(activationId);
    };

    return (
        <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ 'horizontal': 'center', 'vertical': 'bottom' }}>
                <Alert onClose={handleClose} severity={msgType} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <div className="row">
                    <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">
                        <div className="kt-grid__item kt-grid__item--fluid kt-app__content">
                            <div className="kt-portlet" style={{ marginTop: 20 }}>
                                <div className="kt-portlet__head">
                                <div className='' style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>

                                    <div className="kt-portlet__head-label">
                                        {isLoading === false ? (
                                            <h3 className="kt-portlet__head-title">{Languages.TopupESIM}</h3>
                                        ) : (
                                            <Skeleton animation="wave" sx={{ borderRadius: 1 }} width={150} variant="text" />
                                        )}
                                    </div>
                                    {isLoading === false ? (<select className="form-select custom-select kt_selectpicker" style={{ width: 250 }} value={eSIMName} onChange={handleChange} name="activation">
                                        {/* <option value="">{Languages.SelectSIM}</option> */}
                                        {customer_activations.map((person, i) => <option className="m--bg-success kt-font-inverse-success" country_name={person.country_name} iccid={person.iccid} activationId={person.activation_id} value={person.country_name + ' - ' + person.iccid} key={i.toString()}>{person.iccid}</option>)}

                                    </select>
                                    ) : (
                                        <Skeleton animation="wave" sx={{ borderRadius: 1, display: 'flex', width: 250, height: 35 }} />
                                    )}
                                </div>
                                </div>

                                {customer_activations.length > 0 ? (
                                    <>
                                        <Elements stripe={stripePromise}>
                                            {isLoading === false ? (
                                                <>
                                                    {planList && (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                marginLeft: isMobile ? 15 : 50,
                                                                marginRight: isMobile ? 15 : 50,
                                                                marginTop: 20,
                                                            }}
                                                        >
                                                            {planList.map((item, i) => (
                                                                <PlanItem
                                                                    showMsg={showMsg}
                                                                    key={i}
                                                                    type={Languages.TopupESIM}
                                                                    colorInfo={colorData}
                                                                    planData={item}
                                                                    onContinue={onContinueTopup}
                                                                />
                                                            ))}
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className='row' style={{ marginLeft: isMobile ? 15 : 80, marginRight: isMobile ? 15 : 80, marginTop: 20 }}>
                                                    {Constants.ButtonList.map(item => (
                                                        <div className={'col-lg-4'}>
                                                            {/* <div className='col-lg-4 cntryBox' style={{marginTop: 30, padding: 0,margin: 0}}> */}
                                                            <Skeleton className='cntryBox' animation="wave" sx={{ borderRadius: 1 }} width={'100%'} height={80} />

                                                        </div>

                                                    ))}
                                                </div>
                                            )}
                                        </Elements>
                                    </>
                                ) : (
                                    <div
                                        className="col-lg-12"
                                        style={{
                                            padding: isMobile ? 20 : 50,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginTop: isMobile ? 10 : 50,
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                            }}
                                        >
                                            {isLoading === false ? (
                                                <>
                                                    <i
                                                        className="fa fa-qrcode"
                                                        style={{ fontSize: "6em" }}
                                                        aria-hidden="true"
                                                    ></i>
                                                    <h4
                                                        style={{
                                                            marginTop: 10,
                                                            textAlign: "center",
                                                            color: Colors.Black,
                                                        }}
                                                    >
                                                        {Languages.NoeSIM}
                                                    </h4>
                                                    <h6
                                                        style={{
                                                            marginTop: 10,
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {Languages.NoeSIMInfo}
                                                    </h6>
                                                    <div
                                                        style={{
                                                            backgroundColor: Colors.Primary,
                                                            textAlign: "center",
                                                            height: 35,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            borderRadius: 5,
                                                            color: Colors.White,
                                                            paddingLeft: 20,
                                                            paddingRight: 20,
                                                            marginTop: 10,
                                                        }}
                                                        onClick={() => {
                                                            history.push("/purchaseplan");
                                                        }}
                                                    >
                                                        {Languages.NoSIMBtnTxt}
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <Skeleton
                                                        animation="wave"
                                                        sx={{ borderRadius: 2, height: 100, width: 100 }}
                                                    />
                                                    <Skeleton
                                                        animation="wave"
                                                        sx={{
                                                            borderRadius: 2,
                                                            height: 30,
                                                            width: 200,
                                                            marginTop: -1,
                                                        }}
                                                    />
                                                    <Skeleton
                                                        animation="wave"
                                                        sx={{
                                                            borderRadius: 2,
                                                            height: 30,
                                                            width: 200,
                                                            marginTop: -1,
                                                        }}
                                                    />
                                                    <Skeleton
                                                        animation="wave"
                                                        sx={{
                                                            borderRadius: 2,
                                                            height: 40,
                                                            width: 100,
                                                            marginTop: 1,
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BootstrapDialog
                onClose={handleModalClose}
                aria-labelledby="customized-dialog-title"
                open={openModal}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleModalClose}>
                    {Languages.TitleInfoDialog}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <div className='row' style={{ padding: 20 }}>
                        {Constants.ButtonList.map(item => {
                            return (
                                <div className='col-lg-6' style={{ padding: 10 }} onClick={() => {
                                    if (item.id !== 4) {
                                        clearPlanList();
                                        getTopupPlanList(activation_id);
                                        history.push('/plan-list')
                                    }
                                    // else{
                                    //     clearPlanList();
                                    //     getTelsimPlanList(1, Languages.Local);
                                    //     handleModalClose();
                                    //     history.push('/plan-list')
                                    // }

                                }}>
                                    <div style={{ backgroundColor: Colors.Primary, textAlign: 'center', height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 5, color: Colors.White }}>
                                        {item.name}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleModalClose}>
                        Close
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}

export default withRouter(ChangeBundle);